import { useCallback, useState } from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from '../../../../providers/data-provider/quiz-assessment-test.data.provider';
import { AnswerSheetPhotoCard } from './answer-sheet-photo-card';
import { QuestionCard } from './question-card';
import { StudentProgressCard } from './student-progress-card';
import { SubmitFooter } from './submit-footer';
import { BLANK_ANSWER } from './constants';
import { mapExtractedAnswers } from './utils';

export function AnsweringStep({ testCode, testInfo, answerKey, onChangeCode, onSaved }) {
  const notify = useNotify();
  const { correctTest } = useQuizAssessmentTestDataProvider();
  const [givenAnswers, setGivenAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleSelect = useCallback((questionId, optionId) => {
    setGivenAnswers((prev) => ({ ...prev, [questionId]: optionId }));
  }, []);

  const handleAnswersExtracted = useCallback((extractedAnswers) => {
    const mapped = mapExtractedAnswers(extractedAnswers, answerKey);
    // Keep the questions the user manually marked as blank untouched.
    setGivenAnswers((prev) => {
      const next = { ...prev };
      Object.keys(mapped).forEach((questionId) => {
        if (prev[questionId] !== BLANK_ANSWER) next[questionId] = mapped[questionId];
      });
      return next;
    });
  }, [answerKey]);

  const handleSubmit = useCallback(() => {
    const response = Object.keys(givenAnswers).map((questionId) => {
      const isBlank = givenAnswers[questionId] === BLANK_ANSWER;
      return { questionId, optionId: isBlank ? null : givenAnswers[questionId], isBlank };
    });
    setSubmitting(true);
    correctTest(testCode, testInfo?.userContext?.id, response).then((res) => {
      onSaved(res.data);
    }).catch(() => {
      notify('Erro ao salvar resultados !', 'error');
      setSubmitting(false);
    });
  }, [correctTest, testCode, testInfo, givenAnswers, onSaved, notify]);

  const answeredCount = Object.keys(givenAnswers).length;
  const allQuestionsAnswered = answerKey.length > 0 && answeredCount === answerKey.length;

  return (
    <>
      <StudentProgressCard
        studentName={testInfo?.studentName}
        answeredCount={answeredCount}
        totalQuestions={answerKey.length}
        onChangeCode={onChangeCode}
      />
      <AnswerSheetPhotoCard onAnswersExtracted={handleAnswersExtracted} />
      {answerKey.map((question) => (
        <QuestionCard
          key={question.questionId}
          question={question}
          selectedOptionId={givenAnswers[question.questionId]}
          onSelect={handleSelect}
        />
      ))}
      <SubmitFooter
        onSubmit={handleSubmit}
        submitting={submitting}
        disabled={!allQuestionsAnswered}
      />
    </>
  );
}
